import { render, staticRenderFns } from "./AssetAllocations.vue?vue&type=template&id=4c861a7c&scoped=true&"
import script from "./AssetAllocations.vue?vue&type=script&lang=js&"
export * from "./AssetAllocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c861a7c",
  null
  
)

export default component.exports